import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import pickerOption from '@/mixins/module/pickerOption';
import { serverList, articlesList, getUserProd } from "@/api/gmtool/packageCode";
import { mapState } from 'vuex';
export default {
  mixins: [pickerOption],
  data: function data() {
    return {
      announcementTypes: [{
        label: '普通公告',
        value: 0
      }, {
        label: '停服公告',
        value: 1
      }, {
        label: '新服开服',
        value: 2
      }],
      serverLists: [],
      serverMergeList: [],
      paramsData: {
        is_prod: '',
        page_size: 10
      },
      langList: [{
        label: this.$t('langSimplifiedChinese'),
        value: 'cn'
      }, {
        label: this.$t('langTraditionalChinese'),
        value: 'tc'
      }, {
        label: this.$t('langEnglish'),
        value: 'en'
      }, {
        label: this.$t('langThai'),
        value: 'th'
      }, {
        label: this.$t('langVietnamese'),
        value: 'vn'
      }, {
        label: this.$t('langRussian'),
        value: 'ru'
      }, {
        label: this.$t('langIndonesian'),
        value: 'in'
      }],
      configState: [{
        label: this.$t('dynamicCalculation'),
        value: 0
      }, {
        label: this.$t('maintenance'),
        value: 1
      }, {
        label: this.$t('new'),
        value: 2
      }, {
        label: this.$t('full'),
        value: 3
      }, {
        label: this.$t('crowded'),
        value: 4
      }, {
        label: this.$t('smooth'),
        value: 5
      }],
      recommList: [{
        label: this.$t('neitherRecommendNorActivityZone'),
        value: 0
      }, {
        label: this.$t('onlyRecommend'),
        value: 1
      }, {
        label: this.$t('onlyActivityZone'),
        value: 2
      }, {
        label: this.$t('bothRecommendAndActivityZone'),
        value: 3
      }],
      refreshDuration: [{
        label: this.$t('refreshDaily'),
        value: 'd'
      }, {
        label: this.$t('refreshWeekly'),
        value: 'w'
      }, {
        label: this.$t('refreshMonthly'),
        value: 'm'
      }],
      tagggList: [{
        label: this.$t('noTag'),
        value: 0
      }, {
        label: this.$t('recommend'),
        value: 1
      }, {
        label: this.$t('new'),
        value: 2
      }, {
        label: this.$t('hot'),
        value: 3
      }, {
        label: this.$t('serverStopAnnouncement'),
        value: 4
      }],
      FillIn: {
        en: 'Dear Captain, the server is currently under maintenance. Expected opening time: %s. Thank you for your patience.',
        enT: 'Dear Captain, the server is currently under maintenance. Expected opening time: %s. Thank you for your patience.',
        cn: '亲爱的船长，当前服务器维护中，预计开服时间：%s，请耐心等待。',
        cnT: '亲爱的船长，当前服务器维护中，预计开服时间：%s，请耐心等待。',
        tc: '親愛的船長，當前伺服器維護中，預計開服時間：%s，請耐心等待。',
        tcT: '親愛的船長，當前伺服器維護中，預計開服時間：%s，請耐心等待。',
        th: 'กัปตันที่รัก ขณะนี้เซิร์ฟเวอร์อยู่ระหว่างการปรับปรุง คาดว่าจะเปิดให้บริการเวลา: %s โปรดอดทนรอ',
        vn: 'Thuyền trưởng thân mến, máy chủ hiện đang bảo trì, thời gian mở lại dự kiến: %s, vui lòng kiên nhẫn chờ đợi.',
        vnT: 'Thuyền trưởng thân mến, máy chủ hiện đang bảo trì, thời gian mở lại dự kiến: %s, vui lòng kiên nhẫn chờ đợi.',
        ru: 'Дорогой Капитан, в настоящее время сервер находится на техническом обслуживании. Ожидаемое время открытия: %s. Пожалуйста, проявите терпение.',
        in: 'Kapten yang terhormat, server saat ini sedang dalam pemeliharaan, perkiraan waktu buka: %s, mohon bersabar.'
      },
      FillInTitle: {
        en: "Notice",
        cn: "停服公告",
        tc: "停服公告",
        th: "ประกาศแจ้งปิดปรับปรุง",
        vn: "Notice",
        ru: 'Объявление о остановке сервера',
        in: 'Pengumuman Penghentian Server'
      },
      NewSuitlIn: {
        en: 'The Journey to the Stars and Seas Begins Today!A brand-new nautical-themed strategy management mobile game officially sets sail! Here, you will become a maritime adventurer, manage an exploration fleet, recruit unique crew members, and explore this mysterious ocean.Stars Align, Chess Battles Span the Seas,Featuring innovative card + auto-chess gameplay, with over 100 distinctive navigators to mix and match, more than 20 professional traits, and intense combat strategy. Every voyage presents a fresh strategic challenge!Golden Stronghold, Masterful Management,Transform a dilapidated dock into a golden stronghold, and turn humble thatched huts into advanced smelting houses and forging workshops. Massive resources are produced here, bringing abundant rewards.Say No to Grinding, Idle Your Way to Victory,No hassle in progression! Offline treasure chests allow you to claim vast resources with one tap. Meticulously designed and packed with benefits, it rejects complexity so you can fully immerse yourself in this sailing world.Exclusive Gift Code: VIP111, VIP222, VIP777(Customer Service: Click on Avatar - System Settings - Customer Service to contact us)',
        cn: '星辰大海的征途今日开启！全新航海题材策略经营手游正式鸣笛启航！在这里，您将化身航海冒险家，经营探险舰队，招募个性船员，探索这片神秘海域。星罗棋布 棋战四海。超新颖的卡牌+自走棋玩法，100+特色航海家自由搭配，20+职业特性，极强的战斗策略性，每次出航都是全新策略考验。黄金据点 经营有道，从破败码头到黄金据点，从一个个小茅草屋经营成高级冶炼房，高级锻造室，海量资源从这里产出，收益满满。不肝不肝 挂机通关。养成不费心，离线宝箱，一键领取海量资源，精心设计，福利满满，拒绝繁杂，尽情领略这航海世界。专属礼包码：VIP111, VIP222, VIP777(客服：点击头像-系统设置-客服，即可联系客服)',
        tc: '星辰大海的征途今日開啟！全新航海題材策略經營手遊正式鳴笛啟航！在這裡，您將化身航海冒險家，經營探險艦隊，招募個性船員，探索這片神秘海域。星羅棋佈 棋戰四海。超新穎的卡牌+自走棋玩法，100+特色航海家自由搭配，20+職業特性，極強的戰鬥策略性，每次出航都是全新策略考驗。黃金據點 經營有道，從破敗碼頭到黃金據點，從一個個小茅草屋經營成高級冶煉房、高級鍛造室，海量資源從這裡產出，收益滿滿。不肝不肝 掛機通關。養成不費心，離線寶箱，一鍵領取海量資源，精心設計，福利滿滿，拒絕繁雜，盡情領略這航海世界。專屬禮包碼：VIP111, VIP222, VIP777(客服：點擊頭像-系統設置-客服，即可聯繫客服)',
        th: 'การเดินทางสู่ห้วงอวกาศอันกว้างใหญ่เริ่มต้นขึ้นแล้ววันนี้! เกมมือถือกลยุทธ์จำลองการจัดการแนวใหม่ในธีมการเดินเรือได้เปิดตัวอย่างเป็นทางการ! ที่นี่ คุณจะได้เปลี่ยนบทบาทเป็นนักผจญภัยทางเรือ จัดกองเรือสำรวจ รับสมัครนักเดินเรือหลากหลายบุคลิก สำรวจน่านน้ำลึกลับแห่งนี้ ดวงดาวประดับฟ้า กระดานหมากรุกรบทัพทั่วทะเล เกมการ์ด + Auto Battler ใหม่ล่าสุด นักเดินเรือพิเศษกว่า 100 ตัวอิสระในการจัดทีม ลักษณะเฉพาะอาชีพกว่า 20 แบบ กลยุทธ์การต่อสู้ที่เข้มข้น ทุกครั้งที่ออกเรือคือบททดสอบกลยุทธ์ใหม่สุด ฐานที่มั่นทองคำ จัดการอย่างชาญฉลาด จากท่าเรือรกร้างสู่ฐานที่มั่นทองคำ จากกระท่อมหลังเล็กๆ จัดการเป็นโรงถลุงแร่ขั้นสูง โรงตีเหล็กขั้นสูง แหล่งทรัพยากรมหาศาลผลิตจากที่นี่ ผลตอบแทนอันล้นเหลือ ไม่ต้องเล่นหนัก วางมือก็ผ่านได้ การพัฒนาตัวละครไม่เปลืองใจ กล่องทรัพยากรออฟไลน์ กดรับทรัพยากรปริมาณมากด้วยคลิกเดียว ออกแบบอย่างประณีต เต็มไปของรางวัล และไม่มีความซับซ้อน เพลิดเพลินไปกับโลกการเดินเรือแห่งนี้ โค้ดของขวัญพิเศษ: VIP111, VIP222, VIP777(ฝ่ายบริการลูกค้า: คลิกที่รูปโปรไฟล์ - การตั้งค่าระบบ - ฝ่ายบริการลูกค้า เพื่อติดต่อ)',
        vn: 'Hành trình chinh phục biển sao chính thức bắt đầu từ hôm nay! Tựa game mobile chiến thuật kinh doanh lấy đề tài hải trình hoàn toàn mới đã chính thức kéo còi ra khơi! Tại đây, bạn sẽ hóa thân thành nhà mạo hiểm đại dương, quản lý hạm đội thám hiểm, chiêu mộ các thuyền viên cá tính và khám phá vùng biển bí ẩn này.Bàn cờ ma thuật, xưng bá bốn phương. Lối chơi kết hợp Cờ nhân phẩm (Auto Chess) và Thẻ bài cực kỳ mới lạ với hơn 100 hải trình gia độc đáo tự do phối hợp, hơn 20 đặc tính nghề nghiệp mang lại tính chiến thuật chuyên sâu. Mỗi chuyến ra khơi đều là một thử thách chiến thuật hoàn toàn mới.Thủ phủ hoàng kim, kinh doanh có thuật. Từ một bến cảng hoang tàn phát triển thành thủ phủ hoàng kim, từ những túp lều tranh nhỏ bé kinh doanh thành xưởng luyện kim và phòng rèn cao cấp, nguồn tài nguyên dồi dào liên tục được sản xuất, mang lại lợi nhuận khổng lồ.   Không rảnh vẫn ngầu, treo máy qua màn. Nâng cấp không tốn sức, rương báu offline nhận ngay vô số tài nguyên chỉ với một cú nhấp. Thiết kế tinh tế, ngập tràn phúc lợi, tạm biệt thao tác rườm rà để thỏa sức trải nghiệm thế giới đại dương bao la!Mã quà tặng đặc quyền: VIP111, VIP222, VIP777 (Chăm sóc khách hàng: Nhấn vào Avatar - Cài đặt hệ thống - Chăm sóc khách hàng để liên hệ).',
        ru: 'Сегодня начинается великое путешествие по звёздным морям!Новая стратегическая мобильная игра о морских приключениях официально отправляется в плавание!Здесь вы станете настоящим морским авантюристом: управляйте экспедиционным флотом, нанимайте уникальных моряков и исследуйте загадочные воды этого огромного океана.Морская стратегия — сражения по всему свету.Совершенно новый игровой процесс: карточная система + автобаттлер.Более 100 уникальных мореплавателей для свободных комбинаций, 20+ классов и особенностей, глубокая боевая стратегия — каждое плавание станет новым испытанием для вашей тактики.Золотые базы — искусство управления.От разрушенного причала до настоящей золотой базы.Развивайте поселение: превращайте простые хижины в плавильные мастерские и кузницы, производите огромное количество ресурсов и увеличивайте прибыль.Без гринда — играйте легко.Развитие без лишних усилий!Оффлайн-сундуки, мгновенное получение ресурсов одним нажатием, множество наград и удобная система прогресса.Наслаждайтесь миром морских приключений без лишней рутины.Эксклюзивные подарочные коды:VIP111, VIP222, VIP777(Служба поддержки: Нажмите аватар → Настройки → Поддержка, чтобы связаться со службой поддержки.)',
        in: 'Perjalanan menuju lautan bintang telah dimulai hari ini! Game strategi manajemen terbaru bertema maritim resmi berlayar! Di sini, Anda akan berperan sebagai petualang maritim, mengelola armada ekspedisi, merekrut kru dengan karakteristik unik, dan menjelajahi perairan misterius ini.Taktik di Papan Catur, Kuasai Lautan.Gameplay kartu + auto chess yang sangat inovatif, lebih dari 100 karakter pelaut unik dapat dipadukan secara bebas, lebih dari 20 karakteristik profesi, memberikan strategi pertempuran yang sangat mendalam. Setiap pelayaran adalah tantangan strategi yang baru.Benteng Emas, Manajemen yang Cerdas.Dari dermaga yang hancur menjadi benteng emas, dari gubuk jerami kecil dikelola menjadi pabrik peleburan tingkat tinggi, bengkel tempa canggih. Sumber daya yang melimpah dihasilkan di sini, penuh dengan keuntungan.Santai, Bisa Tamat Sambil AFK.Tidak perlu repot mengurus karakter. Peti harta karun offline, klaim sumber daya berlimpah dengan satu sentuhan. Dirancang dengan penuh perhatian, penuh dengan kemudahan. Tolak kerumitan, nikmati sepenuhnya dunia pelayaran ini.Kode hadiah eksklusif: VIP111, VIP222, VIP777(Layanan Pelanggan: Klik Avatar - Pengaturan Sistem - Layanan Pelanggan untuk menghubungi kami)'
      },
      autoServerTitle: {
        en: 'Announcement: "Voyage Tactics" Server Launch on August 6 Dear Captains,Thank you to millions of players for your pre-registrations and patient waiting! Voyage Tactics has officially launched its open beta on August 6, 2026, at 10:00 AM! Welcome to an all-new, cozy 3D cartoon water world!Here, you can experience relaxing ocean exploration, light strategy deck battles, and authentic SLG island management tailored to your playstyle—whether you want to grind or take it easy. Enjoy peaceful farming and island-building, or engage in resource competition and team raid adventures. With idle mechanics, you can easily gather resources offline and enjoy constant progression whenever you log in!To show our gratitude for your support, exclusive launch rewards are now unlocked![Exclusive Launch Benefits]1,000 Free Draws at StartNew players can unlock 1,000 free pulls right upon logging in! Reroll until you get your favorite bond lineup before starting your adventure. Zero-stress progression and an easy way to complete your character index!Pre-registration Milestone RewardsLog in to claim the exclusive SSR [Tomboy], an exclusive limited avatar frame, and massive progression materials.[Beta Top-Up Rebate]All purchases made by players during the test period will be refunded with high-value rebates upon open beta launch. Rewards will be sent via in-game mail.May all captains ride the wind and waves, build their islands, expand across the seas, and embark on their own legendary voyage!Voyage Tactics Operations Team August 6, 2026',
        cn: '《航海奇兵》8月6日开服公告 亲爱的船长们：感谢百万玩家的预约与守候，《航海奇兵》已于2026年8月6日10:00正式公测首发！全新3D卡通治愈水世界来袭！在这里，你可以体验轻松治愈的海域探险、不烧脑的轻策略甲板战斗、可肝可佛的真实SLG海岛经营。既能悠闲种田发育、经营海岛家园，也能争夺资源地盘、组队团战冒险，搭配离线放置挂机玩法，下线轻松收菜，上线满满爽点！为回馈每一位船长的等待与支持，游戏专属首发福利全面解锁！【首发专属福利】1. 开局千抽特权:新手上线即可解锁千抽自由，刷出满意羁绊阵容再开局，开荒零压力，轻松集齐全图鉴！2. 预约里程碑专属奖励:玩家登录即可领取限定SSR【假小子】、专属限定头像框、海量开荒养成材料。【 测试充值返利】所有玩家测试期间的充值金额，公测开启后可按比例领取高额返利，奖励统一发放至游戏邮件。祝愿各位船长乘风破浪，筑岛拓海，开启专属你的航海奇遇！《航海奇兵》运营团队2026年8月6日',
        tc: '《航海奇兵》8月6日開服公告 親愛的船長們：感謝百萬玩家的預約與守候，《航海奇兵》已於2026年8月6日10:00正式公測首發！全新3D卡通治癒水世界來襲！在這裡，你可以體驗輕鬆治癒的海域探險、不燒腦的輕策略甲板戰鬥、可肝可佛的真實SLG海島經營。既能悠閒種田發育、經營海島家園，也能爭奪資源地盤、組隊團戰冒險，搭配離線放置掛機玩法，下線輕鬆收菜，上線滿滿爽點！為回饋每一位船長的等待與支持，遊戲專屬首發福利全面解鎖！【首發專屬福利】1. 開局千抽特權:新手上線即可解鎖千抽自由，刷出滿意羈絆陣容再開局，開荒零壓力，輕鬆集齊全圖鑑！2. 預約里程碑專屬獎勵:玩家登錄即可領取限定SSR【假小子】、專屬限定頭像框、海量開荒養成材料。【測試充值返利】所有玩家測試期間的充值金額，公測開啟後可按比例領取高額返利，獎勵統一發放至遊戲郵件。祝願各位船長乘風破浪，築島拓海，開啟專屬你的航海奇遇！《航海奇兵》營運團隊2026年8月6日',
        th: 'ประกาศเปิดเซิร์ฟเวอร์ "Voyage Tactics" วันที่ 6 สิงหาคม เรียน กัปตันทุกท่าน ขอขอบคุณผู้เล่นนับล้านที่ร่วมลงทะเบียนล่วงหน้าและอดทนรอคอย! "Voyage Tactics" ได้เปิด Open Beta อย่างเป็นทางการแล้วในวันที่ 6 สิงหาคม 2026 เวลา 10:00 น.! สัมผัสประสบการณ์โลกใต้น้ำฮีลใจสไตล์การ์ตูน 3D รูปแบบใหม่ได้แล้ววันนี้!ที่นี่ คุณจะได้ผจญภัยในคาบสมุทรสุดผ่อนคลาย การต่อสู้บนดาดฟ้าเรือเชิงกลยุทธ์เบาๆ ไม่ซับซ้อน และการบริหารจัดการเกาะสไตล์ SLG ที่เลือกเล่นได้ตามใจชอบ ทั้งสายชิลและสายฟาร์ม ไม่ว่าจะปลูกผักพัฒนาบ้านเรือนอย่างสงบ หรือจะแย่งชิงทรัพยากรและลุยศึกกิลด์ ก็ทำได้ง่ายๆ พร้อมระบบต่อสู้อัตโนมัติแบบออฟไลน์ รับทรัพยากรชิลๆ ตอนออฟไลน์ และเข้ามารับความฟินแบบจัดเต็มตอนออนไลน์!เพื่อตอบแทนการรอคอยและการสนับสนุนของกัปตันทุกคน รางวัลเปิดเซิร์ฟเวอร์สุดพิเศษได้ปลดล็อกแล้ว![สิทธิพิเศษช่วงเปิดตัว]อภิสิทธิ์สุ่มฟรี 1,000 สุ่มช่วงเปิดเกมผู้เล่นใหม่เข้าเกมรับสิทธิ์สุ่มฟรี 1,000 ครั้งทันที! จัดทีมพันธนาการที่ถูกใจก่อนเริ่มเล่น ฟาร์มสบายไร้แรงกดดัน และสะสมสมุดภาพครบได้อย่างง่ายดาย!รางวัลบรรลุยอดลงทะเบียนล่วงหน้าล็อกอินเพื่อรับฮีโร่ SSR ลิมิเต็ด [ทอมบอย], กรอบโปรไฟล์ลิมิเต็ดสุดพิเศษ และวัตถุดิบอัปเกรดมากมาย[รีเบตเติมเงินช่วงทดสอบ]ยอดเติมเงินทั้งหมดของผู้เล่นในช่วงทดสอบ จะได้รับโบนัสคืนเงินมูลค่าสูงตามสัดส่วนหลังเปิด Open Beta โดยรางวัลจะถูกส่งไปยังกล่องจดหมายในเกม ขอให้กัปตันทุกท่านฝ่าฟันคลื่นลม ขยายดินแดนเกาะ และเริ่มต้นการผจญภัยทางทะเลสุดพิเศษของคุณ!ทีมงานผู้ให้บริการ "Voyage Tactics" 6 สิงหาคม 2026',
        vn: 'Thông Báo Mở Server "Voyage Tactics" Ngày 06/08 Kính gửi các Thuyền Trưởng,Cảm ơn hàng triệu người chơi đã đăng ký trước và đồng hành chờ đợi! Voyage Tactics đã chính thức mở Open Beta vào lúc 10:00 ngày 06/08/2026! Thế giới đại dương 3D phong cách hoạt hình cực kỳ thư giãn đã chính thức ra mắt!Tại đây, bạn có thể trải nghiệm hành trình khám phá biển cả nhẹ nhàng, các trận chiến trên boong tàu chiến thuật vừa sức, cùng lối chơi quản lý đảo SLG chân thực có thể cày cuốc hoặc giải trí tùy thích. Bạn vừa có thể thong thả trồng trọt phát triển đảo, vừa có thể tranh đoạt tài nguyên, lập đội chiến đấu tổ đội, kết hợp với cơ chế treo máy offline—nhận quà thả ga khi đăng nhập lại! Để tri ân sự chờ đợi và ủng hộ của các Thuyền Trưởng, phần thưởng ra mắt đặc quyền đã chính thức được khai mở![Đặc Quyền Ra Mắt Exclusive]Đặc Quyền 1,000 Lượt Quay Đầu GameTân thủ đăng nhập là có thể nhận ngay 1,000 lượt quay tự do! Chờ đến khi quay ra đội hình duyên phận ưng ý mới bắt đầu chơi, khai phá không chút áp lực, dễ dàng thu thập trọn bộ sưu tập!Phần Thưởng Mốc Đăng Ký TrướcĐăng nhập nhận ngay SSR Giới Hạn [Cô Nàng Cá Tính], Khung Avatar Giới Hạn và vô số nguyên liệu nâng cấp ban đầu. [Hoàn Trả Nạp Tiền Bát Mở Test]Toàn bộ số tiền nạp của người chơi trong thời gian thử nghiệm sẽ được hoàn trả theo tỷ lệ cao khi game ra mắt chính thức, phần thưởng sẽ được gửi trực tiếp qua Hộp Thư trong game.Chúc các Thuyền Trưởng thuận phong rẽ sóng, xây đảo mở cõi và bắt đầu chuyến hải trình kỳ thú của riêng mình! Đội Ngũ Vận Hành Voyage TacticsNgày 06 tháng 08 năm 2026',
        ru: 'Объявление об открытии сервера "Voyage Tactics" — 6 августа Уважаемые Капитаны!Благодарим миллионы игроков за предварительную регистрацию и ожидание! Официальный открытый бета-тест игры Voyage Tactics стартовал 6 августа 2026 года в 10:00! Встречайте новый уютный 3D-мультяшный водный мир!Здесь вас ждут расслабляющие исследования морских просторов, легкие стратегические битвы на палубе и реалистичное управление островом в стиле SLG, которое подойдет как для активных игроков, так и для любителей медитативного геймплея. Вы можете спокойно заниматься фермерством и обустраивать свой остров, либо сражаться за ресурсы и участвовать в командных боях. А благодаря авто-режиму офлайн, вы легко собираете ресурсы, даже когда находитесь вне игры!В знак благодарности за ваше ожидание и поддержку мы разблокировали эксклюзивные бонусы в честь запуска![Эксклюзивные бонусы запуска]1000 бесплатных призывов на старте Новые игроки получают доступ к 1000 призывам прямо при входе! Соберите идеальный состав отряда с лучшими синергиями и начинайте игру без лишнего стресса, легко собирая полную коллекцию! Награды за достижения предрегистрацииВойдите в игру, чтобы получить лимитированного SSR-героя [Пацанка], эксклюзивную рамку для аватара и огромное количество материалов для развития.[Возврат средств за покупки на тесте] Все покупки, совершенные игроками во время бета-тестирования, будут возвращены в виде щедрых бонусов после запуска ОБТ. Награды будут отправлены на внутриигровую почту. Желаем всем капитанам попутного ветра, новых открытий и незабываемых морских приключений! Команда разработчиков Voyage Tactics6 августа 2026 г.',
        in: 'Pengumuman Pembukaan Server "Voyage Tactics" 6 Agustus Kapten yang terhormat,Terima kasih kepada jutaan pemain atas pra-registrasi dan kesetiaannya menunggu! Voyage Tactics telah resmi meluncurkan Open Beta pada 6 Agustus 2026 pukul 10:00! Selamat datang di dunia air 3D ala kartun yang menenangkan! Di sini, Anda dapat menikmati petualangan laut yang santai, pertarungan strategi ringan di atas geladak kapal, serta pengelolaan pulau SLG nyata yang cocok untuk pemain kasual maupun yang suka grinding. Anda bisa santai bertani dan membangun pulau, atau memperebutkan wilayah sumber daya dan bertarung dalam tim. Dilengkapi dengan sistem idle offline, Anda bisa dengan mudah mengumpulkan hadiah saat offline dan menikmati keseruannya saat online! Untuk mengapresiasi dukungan Anda, hadiah eksklusif peluncuran perdana kini telah dibuka! [Hadiah Eksklusif Peluncuran]Hak Istimewa 1.000 Draw di Awal Game Pemain baru dapat langsung membuka 1.000 kali draw gratis saat login! Pilih susunan tim dengan bond terbaik sebelum memulai petualangan, tanpa beban di awal game, dan kumpulkan seluruh koleksi dengan mudah!Hadiah Pencapaian Pra-Registrasi Login untuk mengklaim pahlawan SSR terbatas [Tomboy], bingkai avatar eksklusif terbatas, dan sejumlah besar material pengembangan. [Rebat Top-Up Masa Uji Coba] Seluruh jumlah top-up pemain selama masa uji coba akan dikembalikan dalam bentuk rebat bernilai tinggi setelah Open Beta dibuka. Hadiah akan dikirimkan secara serentak melalui Kotak Surat di dalam game.Semoga seluruh Kapten dapat menerjang ombak, memperluas wilayah pulau, dan memulai petualangan laut eksklusif Anda sendiri!Tim Operasional Voyage Tactics 6 Agustus 2026'
      },
      NewSuitlInTitle: {
        en: 'Server Launch Announcement',
        cn: '开服公告',
        tc: '開服公告',
        th: 'ประกาศเปิดให้บริการ',
        vn: 'Server Launch Announcement',
        ru: 'Объявление об открытии сервера',
        in: 'Pengumuman Pembukaan Server'
      },
      moduleList: [{
        label: this.$t('no'),
        value: 0
      }, {
        label: this.$t('yes'),
        value: 1
      }],
      templateList: [{
        label: '默认',
        value: 0
      }, {
        label: '更新补偿',
        value: 1
      }, {
        label: '终生累充奖励发放',
        value: 2
      }],
      awardDistribution: [{
        value: "cn",
        title: "终生累充奖励",
        content: "\u4EB2\u7231\u7684VIP,\n     \u611F\u8C22\u60A8\u5BF9\u6E38\u620F\u7684\u559C\u7231\u4E0E\u652F\u6301,\u4EE5\u4E0B\u662F\u60A8\u5728VIP\u7EC8\u751F\u7D2F\u5145\u6D3B\u52A8\u4E2D\u6240\u83B7\u5F97\u7684\u5956\u52B1,\u8BF7\u5C3D\u5FEB\u67E5\u6536\u3002\u6709\u4EFB\u4F55\u7591\u95EE\u8BF7\u8054\u7EDCVIP\u5BA2\u670D\u3002"
      }, {
        value: "tc",
        title: "終身累充獎勵",
        content: "\u89AA\u611B\u7684VIP,\n     \u611F\u8B1D\u60A8\u5C0D\u904A\u6232\u7684\u559C\u611B\u8207\u652F\u6301,\u4EE5\u4E0B\u662F\u60A8\u5728VIP\u7D42\u8EAB\u7D2F\u5145\u6D3B\u52D5\u4E2D\u6240\u7372\u5F97\u7684\u734E\u52F5,\u8ACB\u76E1\u5FEB\u67E5\u6536\u3002\u6709\u4EFB\u4F55\u7591\u554F\u8ACB\u806F\u7D61VIP\u5BA2\u670D\u3002"
      }, {
        value: "en",
        title: "Life Time Recharge Activity",
        content: "Dear VIP Captain,\n     Thanks for your love and support! Here is the gift for life time recharge activity of VIP captain, please check and claim! Any further concerns please contact VIP service anytime."
      }, {
        value: "vn",
        title: "Phần Thưởng Tích Nạp Trọn Đời",
        content: "K\xEDnh th\u01B0a thuy\u1EC1n tr\u01B0\u1EDFng VIP,\n     Ch\xE2n th\xE0nh c\u1EA3m b\u1EA1n \u0111\xE3 y\xEAu th\xEDch v\xE0 \u1EE7ng h\u1ED9 tr\xF2 ch\u01A1i, sau \u0111\xE2y l\xE0 ph\u1EA7n th\u01B0\u1EDFng c\u1EE7a b\u1EA1n trong s\u1EF1 ki\u1EC7n t\xEDch n\u1EA1p tr\u1ECDn \u0111\u1EDDi d\xE0nh cho VIP, vui l\xF2ng ki\u1EC3m tra v\xE0 nh\u1EADn s\u1EDBm nh\u1EA5t c\xF3 th\u1EC3. N\u1EBFu c\xF3 b\u1EA5t k\u1EF3 th\u1EAFc m\u1EAFc n\xE0o vui l\xF2ng li\xEAn h\u1EC7 CSKH VIP."
      }],
      compensationList: [{
        value: "cn",
        title: "更新补偿",
        content: "\u8239\u957F\uFF1A\n    \u4E3A\u4E86\u7ED9\u60A8\u66F4\u597D\u7684\u6E38\u620F\u4F53\u9A8C\uFF0C\u6E38\u620F\u5DF2\u5B8C\u6210\u7248\u672C\u66F4\u65B0\uFF0C\u8239\u957F\u53EF\u66F4\u65B0\u65B0\u7248\u672C\u7EE7\u7EED\u4EAB\u53D7\u6E38\u620F\uFF01\u7ED9\u60A8\u5E26\u6765\u7684\u4E0D\u4FBF\u6211\u4EEC\u6DF1\u8868\u6B49\u610F\uFF0C\u8BF7\u67E5\u6536\u672C\u6B21\u66F4\u65B0\u8865\u507F\u3002\n    \u5177\u4F53\u66F4\u65B0\u5185\u5BB9\u53EF\u901A\u8FC7\u3010\u7CFB\u7EDF\u8BBE\u7F6E\u3011-\u3010\u516C\u544A\u3011\u67E5\u770B\u3002"
      }, {
        value: "tc",
        title: "更新補償",
        content: "\u8239\u9577\uFF1A\n    \u70BA\u4E86\u7D66\u60A8\u66F4\u597D\u7684\u904A\u6232\u9AD4\u9A57\uFF0C\u904A\u6232\u5DF2\u5B8C\u6210\u7248\u672C\u66F4\u65B0\uFF0C\u8239\u9577\u53EF\u66F4\u65B0\u65B0\u7248\u672C\u7E7C\u7E8C\u4EAB\u53D7\u904A\u6232\uFF01 \u9020\u6210\u60A8\u7684\u4E0D\u4FBF\u6211\u5011\u6DF1\u8868\u6B49\u610F\uFF0C\u8ACB\u67E5\u6536\u672C\u6B21\u66F4\u65B0\u88DC\u511F\u3002\n    \u5177\u9AD4\u66F4\u65B0\u5167\u5BB9\u53EF\u900F\u904E\u3010\u7CFB\u7D71\u8A2D\u5B9A\u3011-\u3010\u516C\u544A\u3011\u67E5\u770B\u3002"
      }, {
        value: "en",
        title: "Update compensation",
        content: "Dear Captains,\n    To provide you with a better gaming experience, the game has completed the version update.Captains can update to the new version and continue to enjoy the game.We apologize for any inconvenience and kindly accept this compensation for the update.\n    The updated content can be viewed through [Settings]-[Notice]."
      }, {
        value: "vn",
        title: "Bồi Thường Cập Nhật",
        content: "Thuy\u1EC1n tr\u01B0\u1EDFng:\n     \u0110\u1EC3 mang \u0111\u1EBFn cho b\u1EA1n tr\u1EA3i nghi\u1EC7m t\u1ED1t h\u01A1n, tr\xF2 ch\u01A1i \u0111\xE3 ho\xE0n t\u1EA5t c\u1EADp nh\u1EADt phi\xEAn b\u1EA3n, thuy\u1EC1n tr\u01B0\u1EDFng c\xF3 th\u1EC3 update phi\xEAn b\u1EA3n m\u1EDBi ti\u1EBFp t\u1EE5c t\u1EADn h\u01B0\u1EDFng tr\xF2 ch\u01A1i! Ch\xFAng t\xF4i v\xF4 c\xF9ng xin l\u1ED7i v\xEC mang l\u1EA1i s\u1EF1 b\u1EA5t ti\u1EC7n n\xE0y, vui l\xF2ng ki\u1EC3m tra v\xE0 nh\u1EADn b\u1ED3i th\u01B0\u1EDDng c\u1EADp nh\u1EADt l\u1EA7n n\xE0y.\n    N\u1ED9i dung c\u1EADp nh\u1EADt c\u1EE5 th\u1EC3 c\xF3 th\u1EC3 xem qua C\xE0i \u0111\u1EB7t h\u1EC7 th\u1ED1ng- Th\xF4ng B\xE1o"
      }],
      statusList: [{
        label: '已发送',
        value: '1'
      }, {
        label: '未发送',
        value: '2'
      }],
      sels: [],
      selsString: '',
      currentPage: 1,
      total: 0,
      pageSize: 10,
      pageFn: null,
      tableData: [],
      // 表格数据
      tableCopyTableList: [],
      // 表格copy数据b
      tagList: [{
        name: this.$t('tagAddA'),
        content: '<a href=></a>'
      }, {
        name: this.$t('tagAddB'),
        content: '<b></b>'
      }, {
        name: this.$t('tagAddI'),
        content: '<i></i>'
      }, {
        name: this.$t('tagAddSize'),
        content: '<size=50></size>'
      }, {
        name: this.$t('tagAddColor'),
        content: '<color=#FFFFFF></color>'
      }, {
        name: this.$t('tagAddMaterial'),
        content: '<material=2></material>'
      }, {
        name: this.$t('tagAddQuad'),
        content: '<quad material=1 size=20 x=0.1 y=0.1 width=0.5 height=0.5>'
      }],
      reqLoading: false,
      pageFnName: 'getList',
      serverList: [],
      isMobile: false
    };
  },
  created: function created() {
    this.pageFn = this[this.pageFnName];
    this.paramsData.is_prod = this.severlist.length ? this.severlist[0].value : '';

    if (!this.$store.state.gmTool.init.isreqItemList) {
      this.$store.dispatch('gmTool/init/getItemList');
    }
  },
  activated: function activated() {},
  computed: _objectSpread(_objectSpread({}, mapState("gmTool", {
    articleList: function articleList(state) {
      return state.init.itemList;
    }
  })), mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    },
    rawData: function rawData(state) {
      return state.serchSelect.rawData;
    }
  })),
  methods: {
    handleSelectionChange: function handleSelectionChange(val) {
      var _this = this;

      this.sels = [];
      val.forEach(function (e) {
        _this.sels.push(e.id);
      });
      this.selsString = this.sels.toString();
    },
    getserverList: function getserverList(e) {
      var _this2 = this;

      console.log(1);
      return new Promise(function (resolve, reject) {
        serverList({
          is_prod: _this2.searchData && _this2.searchData.is_prod ? _this2.searchData.is_prod : _this2.paramsData.is_prod
        }).then(function (res) {
          if (res.status == 200) {
            _this2.serverLists = res.data;
            _this2.serverMergeList = res.server_merge_list;
            resolve();
          }
        });
      });
    },
    getServer: function getServer() {
      var _this3 = this;

      this.paramsData.server_id = '';
      this.checked = false;
      serverList({
        is_prod: this.paramsData.is_prod,
        page_size: ''
      }).then(function (res) {
        if (res.status == 200) {
          _this3.serverList = res.data;
        }
      });
    },
    selectYjfmAll: function selectYjfmAll() {
      var _this4 = this;

      this.paramsData.server_id = [];

      if (this.checked) {
        this.serverList.map(function (item) {
          _this4.paramsData.server_id.push(item.serverID);
        });
      } else {
        this.paramsData.server_id = [];
      }
    },
    YjfmSeverChange: function YjfmSeverChange(val) {
      if (val.length === this.serverList.length) {
        this.checked = true;
      } else {
        this.checked = false;
      }
    },
    sizeChange: function sizeChange(e) {
      this.paramsData.page_size = e;
      this.pageFn && this.pageFn(1);
    },
    // 页数改变事件
    handleSizeChange: function handleSizeChange(pageSize) {
      this.currentPage = 1;
      this.pageSize = pageSize;
      this.tableData = this.currentChangePage(pageSize, this.currentPage);
    },
    // 页码改变切换
    handleCurrentChange: function handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.tableData = this.currentChangePage(this.pageSize, currentPage);
    },
    // 分页方法
    currentChangePage: function currentChangePage(size, current) {
      var tablePush = [];
      this.tableCopyTableList.forEach(function (item, index) {
        if (size * (current - 1) <= index && index <= size * current - 1) {
          tablePush.push(item);
        }
      });
      return tablePush;
    },
    checkMobile: function checkMobile() {
      this.isMobile = /Android|webOS|iPhone|iPod|BlackBerry|iPad|Windows Phone/i.test(navigator.userAgent) || window.innerWidth <= 768;
    }
  }
};